import { Injectable } from "@angular/core";
import { catchError, Observable, of, ReplaySubject, switchMap, tap } from "rxjs";
import { MatDialog } from '@angular/material/dialog';
import { UsersService } from '@dal/core';
import { BusinessUnitSelectorComponent } from '@dal/shared-ui';

@Injectable({ providedIn: 'root' })
export class BusinessUnitService {
  private readonly readySubject = new ReplaySubject<void>(1);

  constructor(private userService: UsersService, private dialog: MatDialog) {}

  initialize(): Promise<void> {
    return new Promise((resolve) => {
      this.userService.getCurrentBusinessUnit().pipe(
        switchMap((businessUnit: any) => {
          if (businessUnit?.message?.includes("Please select the business unit to proceed further")) {
            return this.dialog.open(BusinessUnitSelectorComponent, {
              data: {
                dialogHeading: 'Select Your Business Unit:',
                businessUnits: businessUnit.user.business_unit_roles,
                name: `${businessUnit.user.firstname} ${businessUnit.user.lastname}`,
              },
              disableClose: true,
            }).afterClosed().pipe(
              switchMap((selectedUnitId) => this.userService.setCurrentBusinessUnit(selectedUnitId))
            );
          } else {
            return of(null);
          }
        }),
        tap(() => resolve()),
        catchError((err) => {
          console.error('Business Unit Init Failed:', err);
          resolve(); 
          return of(null);
        })
      ).subscribe();
    });
  }

}
